import { AuditInformation } from "@cur8/rich-entity";

export function lastAuditChangeDate(audit: AuditInformation) {
  return audit.lastModified?.timeStamp ?? audit.created?.timeStamp ?? null;
}
